// extracted by mini-css-extract-plugin
export default {"learning_list_wrapper":"DashboardLearningList_learning_list_wrapper__jP-W3","learning_list_item":"DashboardLearningList_learning_list_item__QS5RR"};